import React from "react"

export const useIsInViewport = (
  ref: React.MutableRefObject<HTMLElement | null>,
): boolean => {
  const [isIntersecting, setIsIntersecting] = React.useState(false)

  React.useLayoutEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting)
    })
    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [ref])

  return isIntersecting
}
